import downIcon from '../icons/down.svg';
import closeIcone from '../icons/close.svg';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ = (props) => {
  const { t } = useTranslation();
  const themeColor = JSON.parse(localStorage.getItem('machine'))?.themeColor;
  const { show, setShow, langs } = props;
  let FAQ = [];

  let privacy = [];
  if (themeColor?.faq && themeColor?.faq.length > 0) {
    FAQ = themeColor.faq;
  }
  if (themeColor?.privacy && themeColor?.privacy.length > 0) {
    privacy = themeColor.privacy;
  }

  privacy.forEach((element) => {
    element.content[langs] = element.content[langs]
      ? element.content[langs].split(';')
      : element.content.en.split(';');
  });
  FAQ.forEach((element) => {
    element.content[langs] = element.content[langs]
      ? element.content[langs].split(';')
      : element.content.en.split(';');
  });

  const [page, setPage] = useState(true);
  const [data, setData] = useState(privacy);
  const [title, setTitle] = useState(t(`Frequently Ask Questions`));

  const closeModal = () => {
    setShow(false);
    setPage(true);
  };

  const togglePage = () => {
    page ? setPage(false) : setPage(true);
  };

  useEffect(() => {
    var myDiv = document.getElementById('my-privacy-id');
    if (page) {
      setData(FAQ);
      setTitle(t(`Frequently Ask Questions`));
      if (myDiv) myDiv.scrollTop = 0;
    } else {
      setData(privacy);
      setTitle(t(`Privacy Policy`));
      if (myDiv) myDiv.scrollTop = 0;
    }
  }, [page, show]);

  if (show) {
    return (
      // <Modal show={show} onHide={setCartFull(false)}>
      <div className="privacy-modal-container">
        <div className="privacy-modal-title" style={title?.length > 25 ? { fontSize: '62px' } : {}}>
          {title}
        </div>
        <div className="privacy-modal-second-con" id="my-privacy-id">
          <img src={closeIcone} className="privacy-close-icon" alt="" onClick={closeModal}></img>
          <img
            src={downIcon}
            className={page ? 'privacy-down-icon' : 'privacy-down-icon-upsidedown'}
            alt=""
            onClick={togglePage}
          ></img>
          {data.map((e, i) => {
            let header = e.header[langs] ? e.header[langs] : e.header.en;
            let content = e.content[langs] ? e.content[langs] : e.content.en;
            if (typeof content === 'string') {
              content = [content];
            }

            return (
              <div key={i}>
                <div className="privacy-modal-header">{header}</div>
                {content.map((cont, counti) => (
                  <div key={counti} className="privacy-modal-content">
                    {cont}
                  </div>
                ))}
              </div>
            );
          })}
          {/* <div className="privacy-modal-header">Oops!</div>
          <div className="privacy-modal-content">Your cart is full.</div> */}
        </div>
      </div>
    );
  } else return null;
};

export default FAQ;
